import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import { Add } from '@material-ui/icons';
import centerlineLogo from '../../../images/centerline-logo-new.png';
import { formatDate } from '../../../scripts/utils';
import useReviewStyles from './review-styles';
import { LastReview } from './review-storage';

/**
 * The CENTERLINE AI reviewer, as the first row of the Consultant card: it reads like a consultant's
 * row but is plainly not a person (tinted, accent bar, "AI assistant"). Columns mirror
 * ConfidentialAdditionalReviewRow.
 */

export const AI_ROW_TOOLTIP =
  "Generated by CENTERLINE AI from this project's documents. Not a consultant review. Verify before use.";

interface Props {
  /** Whether the card has a Response column (it is hidden for RFIs). */
  showResponse: boolean;
  last: LastReview | null;
  onReview(): void;
}

export default function CenterlineAiReviewRow({ showResponse, last, onReview }: Props) {
  const classes = useReviewStyles();
  return (
    <TableRow className={classes.row} data-testid="centerline-ai-review-row">
      <TableCell>
        <Tooltip arrow placement="top" title={AI_ROW_TOOLTIP}>
          <div className={classes.reviewer}>
            <img className={classes.mark} src={centerlineLogo} alt="" width={28} height={28} />
            <div>
              <Typography className={classes.name}>CENTERLINE AI</Typography>
              <Chip
                size="small"
                variant="outlined"
                label="AI assistant"
                className={classes.aiChip}
              />
            </div>
          </div>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Typography variant="body2" className={classes.muted}>
          {last ? 'Review available' : 'Not run yet'}
        </Typography>
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Add style={{ marginBottom: 1, marginRight: -4 }} />}
          onClick={onReview}
          style={{ padding: '0px 8px 0px 6px' }}
        >
          Review
        </Button>
      </TableCell>
      {showResponse ? (
        <TableCell>
          {last?.recommendedAction ? (
            <Chip
              size="small"
              variant="outlined"
              color="primary"
              label={last.recommendedAction}
              className={classes.actionChip}
            />
          ) : null}
        </TableCell>
      ) : null}
      <TableCell />
      <TableCell>
        {last ? (
          <Typography variant="body2" className={classes.muted}>
            Last run: {formatDate(last.ranAt, true)}
          </Typography>
        ) : null}
      </TableCell>
      <TableCell />
    </TableRow>
  );
}
